import {
  FieldText,
  FormField,
  FormGrid,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
} from '@dixa/lib-shared-habla';
import { ChangeEvent, useCallback, useState } from 'react';

import { createAppModal } from 'utils/modal';

import styles from './createTagModal.module.scss';

/** A component that displays a modal for creating new tags. */
export const CreateTagModal = createAppModal(
  { type: 'app:createTag' },
  ({ isOpen, modal, meta, hide }): JSX.Element => {
    const [tagName, setTagName] = useState(modal.arg.name || '');

    const handleTagNameChange = (event?: ChangeEvent<HTMLInputElement>) => {
      setTagName(event?.target.value ?? '');
    };

    const handleConfirm = () => {
      meta?.resolve({ tag: { name: tagName, color: null } });

      handleCancel();
    };

    const handleCancel = useCallback(() => {
      setTagName('');
      hide?.();
    }, [hide]);

    return (
      <Modal isOpen={isOpen} onClose={handleCancel} className={styles.modal}>
        <ModalHead onClose={handleCancel} title="Add new tag" />

        <ModalBody>
          <FormGrid>
            <FormField>
              <FieldText
                type="text"
                input={{
                  name: 'tagName',
                  value: tagName,
                  onChange: handleTagNameChange,
                }}
                label="Tag name"
                placeholder="Tag name"
                maxLength={255}
                required
              />
            </FormField>
            {
              //TODO: TEAMS-7873 add color picker for color field
            }
          </FormGrid>
        </ModalBody>

        <ModalFoot
          confirmOnClick={handleConfirm}
          cancelOnClick={handleCancel}
          confirmName="Confirm"
          cancelName="Cancel"
          confirmProps={{
            disabled: !tagName,
          }}
        />
      </Modal>
    );
  },
);
